<template>
  <div class="how-assignment">
    <div class="ha-des">
      <p class="black">问：如何找到并完成自己的作业？</p>
      <p>答：在可瀚学堂的主界面中的【我的作业】，点击卡片内的作业直接进入做作业的页面，在卡片右上角【更多作业】查看所有作业，注意卡片上作业截止时间，及时完成作业！</p>
    </div>
    <div class="ha-img">
      <img src="./img/assignment.png" alt="">
    </div>
  </div>
</template>
<style lang="scss" rel="stylesheet/scss">
  @import '../../../src/assets/css/basic.scss';

  .how-assignment {
    padding: 0 p2r(20);
    width: 100%;
    .ha-des {
      padding: p2r(15) 0;
      font-size: p2r(15);
      color: $a77;
      p {
        margin: p2r(10) 0;
      }
      a {
        color: $blue;
      }
    }
    .ha-img {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
</style>
<script>
  export default{
    data(){
      return {
        msg: 'hello vue'
      }
    },
    created () {
      document.title='如何完成作业? 可瀚学堂-深圳市格熙信息科技有限公司'
      this.$sendAnalytics('点击如何完成作业')
    },
    components: {}
  }
</script>
